module.exports = "/assets/data/4736241e8124d921b7420efddf905218-GU4.data.json";